import {
  GET_MAYBANK_APPOINTMENTS,
  GET_MAYBANK_APPOINTMENTS_FAIL,
  GET_MAYBANK_APPOINTMENTS_SUCCESS,
  GET_MAYBANK_APPOINTMENTS_DETAILS,
  GET_MAYBANK_APPOINTMENTS_DETAILS_FAIL,
  GET_MAYBANK_APPOINTMENTS_DETAILS_SUCCESS,
  ADD_NEW_MAYBANK_APPOINTMENTS,
  ADD_MAYBANK_APPOINTMENTS_SUCCESS,
  ADD_MAYBANK_APPOINTMENTS_FAIL,
  UPDATE_MAYBANK_APPOINTMENTS,
  UPDATE_MAYBANK_APPOINTMENTS_SUCCESS,
  UPDATE_MAYBANK_APPOINTMENTS_FAIL,
  DELETE_MAYBANK_APPOINTMENTS,
  DELETE_MAYBANK_APPOINTMENTS_SUCCESS,
  DELETE_MAYBANK_APPOINTMENTS_FAIL,
  CONFIRM_MAYBANK_APPOINTMENTS,
  CONFIRM_MAYBANK_APPOINTMENTS_SUCCESS,
  CONFIRM_MAYBANK_APPOINTMENTS_FAIL,
  ADD_REMARKS_PRE_APPOINTMENTS,
  ADD_REMARKS_PRE_APPOINTMENTS_SUCCESS,
  ADD_REMARKS_PRE_APPOINTMENTS_FAIL,
  RESET_MAYBANK_APPOINTMENTS_STATE,
} from "./actionTypes";

export const getMaybankAppointments = ({ length, sort, page, name, appointment_at, status, sort_by }) => ({
  type: GET_MAYBANK_APPOINTMENTS,
  payload: { length, sort, page, name, appointment_at, status, sort_by },
});

export const getMaybankAppointmentsSuccess = appointments => ({
  type: GET_MAYBANK_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const getMaybankAppointmentsFail = error => ({
  type: GET_MAYBANK_APPOINTMENTS_FAIL,
  payload: error,
});

export const getMaybankAppointmentsDetails = ({ id }) => ({
  type: GET_MAYBANK_APPOINTMENTS_DETAILS,
  payload: { id },
});

export const getMaybankAppointmentsDetailsSuccess = appointments => ({
  type: GET_MAYBANK_APPOINTMENTS_DETAILS_SUCCESS,
  payload: appointments,
});

export const getMaybankAppointmentsDetailsFail = error => ({
  type: GET_MAYBANK_APPOINTMENTS_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewMaybankAppointments = appointments => ({
  type: ADD_NEW_MAYBANK_APPOINTMENTS,
  payload: appointments,
});

export const addMaybankAppointmentsSuccess = appointments => ({
  type: ADD_MAYBANK_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const addMaybankAppointmentsFail = error => ({
  type: ADD_MAYBANK_APPOINTMENTS_FAIL,
  payload: error,
});

//update 
export const updateMaybankAppointments = ({ id, maybankAppointments }) => ({
  type: UPDATE_MAYBANK_APPOINTMENTS,
  payload: { id, maybankAppointments },
});

export const updateMaybankAppointmentsSuccess = appointments => ({
  type: UPDATE_MAYBANK_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const updateMaybankAppointmentsFail = error => ({
  type: UPDATE_MAYBANK_APPOINTMENTS_FAIL,
  payload: error,
});

//delete 
export const deleteMaybankAppointments = ({ id, data }) => (
  {
    type: DELETE_MAYBANK_APPOINTMENTS,
    payload: { id, data },
  });

export const deleteMaybankAppointmentsSuccess = appointments => ({
  type: DELETE_MAYBANK_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const deleteMaybankAppointmentsFail = error => ({
  type: DELETE_MAYBANK_APPOINTMENTS_FAIL,
  payload: error,
});

//confirm 
export const confirmMaybankAppointments = ({ id, maybankAppointments }) => ({
  type: CONFIRM_MAYBANK_APPOINTMENTS,
  payload: { id, maybankAppointments },
});

export const confirmMaybankAppointmentsSuccess = appointments => ({
  type: CONFIRM_MAYBANK_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const confirmMaybankAppointmentsFail = error => ({
  type: CONFIRM_MAYBANK_APPOINTMENTS_FAIL,
  payload: error,
});

//remarks 
export const addRemakrsPreAppointments = ({ id, maybankAppointments }) => ({
  type: ADD_REMARKS_PRE_APPOINTMENTS,
  payload: { id, maybankAppointments },
});

export const addRemakrsPreAppointmentsSuccess = maybankAppointments => ({
  type: ADD_REMARKS_PRE_APPOINTMENTS_SUCCESS,
  payload: maybankAppointments,
});

export const addRemakrsPreAppointmentsFail = error => ({
  type: ADD_REMARKS_PRE_APPOINTMENTS_FAIL,
  payload: error,
});

//reset
export const resetMaybankAppointmentsState = () => {
  return {
    type: RESET_MAYBANK_APPOINTMENTS_STATE,
  }
}


